import { render, staticRenderFns } from "./header-item.vue?vue&type=template&id=4faf5e9d&scoped=true&"
import script from "./header-item.vue?vue&type=script&lang=js&"
export * from "./header-item.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4faf5e9d",
  null
  
)

export default component.exports